<template>
  <div>
    <v-btn icon :disabled="page === 1" @click="$emit('decrement')" large>
      <v-icon>mdi-arrow-left-circle</v-icon>
    </v-btn>
    <span class="mx-3">Page {{ page }}</span>
    <v-btn
      icon
      :disabled="page === pagesCount"
      @click="$emit('increment')"
      large
    >
      <v-icon>mdi-arrow-right-circle</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ['page', 'pagesCount'],
};
</script>
